import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useNavigate, useLocation } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

export default function Inteligencia() {
    const navigate = useNavigate();
    const location = useLocation();

    // Determina o valor da aba com base no caminho atual da URL
    let value = 0;
    if (location.pathname.endsWith('/inteligencia-processar')) {
        value = 1;
    } else if (location.pathname.endsWith('/inteligencia-feriado')) { // Agora verifica a rota '/online'
        value = 2;
    }
    
    // Se a rota for '/producao/gerar', o valor padrão (0) é mantido.

    const handleChange = (event, newValue) => {
        if (newValue === 0) {
            navigate('/inteligencia/inteligencia-impacto');
        } else if (newValue === 1) {
            navigate('/inteligencia/inteligencia-processar');
        } else if (newValue === 2) {
            navigate('/inteligencia/inteligencia-feriado');
        }
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="Abas de Cupons">
                    <Tab label="Impactos" />
                    <Tab label="Processar" />
                    <Tab label="Feriado" />
                </Tabs>
            </Box>
            {/* O Outlet renderizará o conteúdo do componente da rota aninhada */}
            <Outlet />
        </Box>
    );
}